import { authConfig } from "../apiConfig";

export const schedule_move_to_client = async (data) => {
    try {
        const response = await authConfig.post(`scheduleMovetoclient`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const schedule_move_to_finance = async (data) => {
    try {
        const response = await authConfig.post(`scheduleMandaystoFinance`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const create_invoices = async (data) => {
    try {
        const response = await authConfig.post(`createInvoices`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const change_invoice_status = async (data) => {
    try {
        const response = await authConfig.post(`invoicesStatusChnage`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const get_invoice_status = async () => {
    try {
        const response = await authConfig.post(`invoicesStatus`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_all_invoice_status = async () => {
    try {
        const response = await authConfig.post(`getInvoicesStatus`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_all_invoices_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getAllInvoices`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// for get all completed schedules
export const get_all_completed_schedules_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`CompletedSchedules`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// for get all completed schedule reports
export const get_all_completed_schedule_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`CompletedSchedulereports`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// FOR LIST SCHEDEULE INVOICE

export const get_schedule_Invoice_Details = async (data) => {
    try {
        const response = await authConfig.post(`getInvoicesDetails`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

// FOR INVOICE MOVED TO CLIENT
export const invoice_move_to_finance = async (data) => {
    try {
        const response = await authConfig.post(`SendInvoicesToClient`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

// for get BIN reports
// export const get_all_bin_schedule_reports_with_pagination = async (data) => {
//     try {
//         const response = await authConfig.post(`reportsListiing`, data, { headers: { "Content-Type": "multipart/form-data" } });
//         return response.data;
//     } catch (error) {
//         throw error;
//     }
// };
export const get_all_bin_schedule_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getManagerSupervisorBin`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
// For accepting BIN reports
export const reports_accept = async (data) => {
    try {
        const response = await authConfig.post(`reportsAccept`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};